import { Claim } from 'common/models/page-config.models';
import { useCallback, useMemo } from 'react';
import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';

interface UseClaims {
  claims: Claim[];
  hasClaim: (claims: Claim | Claim[], matchAll?: boolean) => boolean;
}

export default function useClaims(): UseClaims {
  const { activeProject } = useModuleProjectContext();
  const claims: Claim[] = useMemo(() => activeProject?.claims ?? [], [activeProject]);

  const hasClaim = useCallback(
    (userClaims: Claim | Claim[], matchAll: boolean = false): boolean => {
      if (userClaims.length === 0) {
        return true;
      }

      const claimArray: Claim[] = Array.isArray(userClaims) ? userClaims : [userClaims];

      if (matchAll) {
        return claimArray.every((claim) => {
          return claims.find((userClaim) => userClaim === claim);
        });
      }

      return claimArray.some((claim) => {
        return claims.find((userClaim) => userClaim === claim);
      });
    },
    [claims]
  );

  return {
    claims,
    hasClaim,
  };
}

// Dev Testing Notes:
// Insights Only:
//    US - Solid Tumor
//    US - Hematology

// Insights & Interaction Only:
//    US TLL - Nash
//    Medical - Ophthalomology
//    MSL - Oncology

// Insights & Alignment Only:
//    Oncology
